import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-text-chat-actions',
  templateUrl: './text-chat-actions.component.html',
  styleUrls: ['./text-chat-actions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextChatActionsComponent {

  @Input() isInProgress: boolean;
  @Input() isAnswerable: boolean;
  @Input() isWrapUpPanelActive: boolean = false;
  @Input() isUserTyping: boolean;
  @Input() messages;
  @Input() visitorName: string;

  @Output() answerTextChat: EventEmitter<any> = new EventEmitter<any>();

  onAnswerTextChat(): void {
    this.answerTextChat.emit();
  }
}
